import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select, SelectTrigger } from "@activecollab/components";
import PropTypes from "prop-types";
import { fetchCalendars } from "~/store/actions/actions.calendars";
import { getAllCalendars, getInternalCalendars } from "~/store/selectors/selector.calendars";

export const CalendarSelect = ({ selected, onChange, disabled }) => {
  const allCalendars = useSelector(getAllCalendars);
  const calendars = useSelector(getInternalCalendars);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCalendars());
  }, [dispatch]);

  const options = useMemo(() => {
    return calendars.map((calendar) => ({ id: calendar.id, name: calendar.name }));
  }, [calendars]);

  const calendarName = useMemo(() => {
    return allCalendars[selected]?.name;
  }, [allCalendars, selected]);

  const handleChange = useCallback(
    (id) => {
      if (typeof onChange === "function") {
        const calendar = calendars?.find((c) => c.id === id);
        if (calendar) {
          onChange(id, calendar);
        } else {
          onChange(id);
        }
      }
    },
    [calendars, onChange]
  );

  return (
    <Select
      target={
        <SelectTrigger
          disabled={disabled}
          className="tw-w-full"
          data-testid="calendar-select"
        >
          {calendarName ? calendarName : null}
        </SelectTrigger>
      }
      options={options}
      selected={selected > 0 ? selected : null}
      onChange={handleChange}
      forceCloseMenu
    />
  );
};

CalendarSelect.propTypes = {
  selected: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

CalendarSelect.defaultProps = {
  selected: 0,
};
